module.exports = __webpack_public_path__ + "img/ring_y_skip_null_1@3x.ff831e02.png";